module.exports = {"231226100":"绥棱镇","231226101":"上集镇","231226102":"四海店镇","231226103":"双岔河镇","231226104":"阁山镇","231226200":"靠山乡","231226201":"后头乡","231226203":"长山乡","231226205":"克音河乡","231226206":"绥中乡","231226207":"泥尔河乡","231226400":"阁山林场","231226401":"四海店林场","231226402":"三吉台林场","231226403":"半截河林场","231226404":"绥棱林业局","231226500":"绥棱农场","231226580":"种马场","231226581":"良种场","231226582":"奶山羊场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231226.json
// module id = 738
// module chunks = 0